import React, { useState, useRef, useEffect } from "react";
import styles from "./dropdown.module.scss";
import { testIdProps } from "../../../../../utils/testIdProps";

interface CategoryOption {
  value: string;
  label: string;
}

interface CategoryDropdownProps {
  id: string;
  name: string; // Formik field name (e.g., "category")
  formik: any; // Pass your Formik instance
  subCategories: CategoryOption[];
}

const CategoryDropdown: React.FC<CategoryDropdownProps> = ({
  id,
  name,
  formik,
  subCategories,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const selectedLabel = formik.values[name]?.category || "Select Category *";

  // Handle outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
        formik.setFieldTouched(name, true, false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [formik, name]);

  const handleSelect = (option: CategoryOption) => {
    formik.setFieldValue(
      name,
      {
        category_pid: option.value,
        category: option.label,
      },
      true
    ); // Trigger validation immediately
    setOpen(false);
  };

  const handleDropdownClick = () => {
    setOpen((prev) => !prev);
    // Mark field as touched when dropdown is opened
    if (!formik.touched[name]) {
      formik.setFieldTouched(name, true, false);
    }
  };

  
  const hasError =
    formik.touched[name] &&
    (!formik.values[name] ||
      !formik.values[name]?.category ||
      !formik.values[name]?.category_pid ||
      formik.errors[name]);

  return (
    <div className={`${styles.dropdownWrapper} bg-light`} ref={dropdownRef}>
      <div
        {...testIdProps(id)}
        className={`${styles.dropdownButton} ${hasError ? "" : ""}`}
        onClick={handleDropdownClick}
      >
        {selectedLabel} <span className={styles.dropdownArrow}>▾</span>
      </div>

      {open && (
        <div className={`${styles.dropdownMenu} `}>
          {subCategories.length === 0 ? (
            <div className={`${styles.dropdownItem} text-muted`}>
              No categories available
            </div>
          ) : (
            subCategories.map((cat) => (
              <div
                key={cat.value}
                {...testIdProps(`category-option-${cat.value}`)}
                className={`${styles.dropdownItem} ${
                  formik.values[name]?.category === cat.label ? styles.active : ""
                }`}
                onClick={() => handleSelect(cat)}
              >
                {cat.label}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default CategoryDropdown;
